<!--==============================
=            BASEMENU            =
===============================-->
<template>




    <div class="d-none d-lg-block">

      
        <v-menu :rounded="rounded" offset-y transition="slide-x-transition">
            <template v-slot:activator="{ on, attrs }">
                <v-btn :class="$vuetify.theme.dark ? 'white--text' : 'white--text'" class="rounded-lg ma-1 ml-1"
                       v-bind="attrs" outlined v-on="on" icon>
                    <v-icon size="28">mark_as_unread</v-icon>
                </v-btn>
            </template>
            <v-list :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'">
                <v-list-item v-for="chat in recent" :key="chat.title">
                    <v-list-item-avatar class="rounded-lg">
                        <v-img :src="require(`../../assets/images/users/${chat.avatar}.jpg`)"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title v-text="chat.title"></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar>
                        <v-icon :color="chat.active ? 'deep-purple accent-4' : 'grey'">

                        </v-icon>
                    </v-list-item-avatar>
                </v-list-item>
            </v-list>
        </v-menu>




        <v-menu offset-y left nudge-bottom="14" min-width="230"
                content-class="user-profile-menu-content slide-y-transition">
            <template v-slot:activator="{ on, attrs }">
                <v-badge bottom color="white" overlap offset-x="16" offset-y="16" class="" dot>
                    <v-btn :class="$vuetify.theme.dark ? 'white--text' : 'white--text'" class=" rounded-lg  mr-1 ml-1"
                           icon outlined v-bind="attrs" v-on="on">
                        <v-avatar size="30px" class="rounded-lg" v-bind="attrs" v-on="on">
                            <v-img :src="require('../../assets/images/2.png')"></v-img>
                        </v-avatar>
                    </v-btn>
                </v-badge>
            </template>
            <v-list dark :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" >
                <div class="pb-3 pt-2">
                    <v-badge bottom color="success" overlap offset-x="12" offset-y="12" class="ms-4" dot>
                        <v-avatar size="30px">
                            <v-img :src="require('../../assets/images/2.png')"></v-img>
                        </v-avatar>
                    </v-badge>
                    <div class="d-inline-flex flex-column justify-center" style="vertical-align: middle">
                        <span class= "white--text font-weight-semibold mb-n1">
                           karine Scott
                        </span>
                        <small class="text--disabled white--text text-capitalize">Admin</small>
                    </div>
                </div>

                <v-divider></v-divider>

                <!-- Profile -->
                <v-list-item @click="goProfile()" link>
                    <v-list-item-avatar class="rounded-lg">
                        <v-icon size="22">account_box </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Email -->
                <v-list-item @click="goInbox()" link>
                    <v-list-item-avatar class="me-2 rounded-lg">
                        <v-icon size="22"> markunread_mailbox</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>Inbox</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Chat -->
                <v-list-item @click="goChat()" link>
                    <v-list-item-avatar class="me-2 rounded-lg">
                        <v-icon size="22"> question_answer</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>Chat</v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                        <v-badge inline color="error" content="2"> </v-badge>
                    </v-list-item-action>
                </v-list-item>

                <v-divider class="my-2"></v-divider>

                <!-- Settings -->
                <v-list-item @click="goSettings()" link>
                    <v-list-item-avatar class="me-2  rounded-lg">
                        <v-icon size="22">settings </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>Settings</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Pricing -->

                <!-- FAQ -->

                <v-divider class="my-2"></v-divider>

                <!-- Logout -->
                <v-list-item @click="goLogin()" link>
                    <v-list-item-avatar class="me-2 primary--text rounded-lg">
                        <v-icon size="22"> arrow_forward</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>Logout</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>

</template>

<script>
    export default {

        name: "base-menu",
        components: {

        }

        ,
        props: {
            value: 1,
            source: String,
            rounded: 'lg'
        }

        ,
        data: () => ({
                expand2: false,
                drawerRight: true,
                files: [{

                        img: 'usa',
                        title: 'USA',
                    },
                    {

                        img: 'ca',
                        title: 'Canada',
                    }, {

                        img: 'ar',
                        title: 'Argentina',
                    },

                    {

                        img: 'uc',
                        title: 'Ukraine',
                    },
                ],
                recent: [{
                        active: true,
                        avatar: '1',
                        title: 'Jason Oner',
                    },
                    {
                        active: true,
                        avatar: '2',
                        title: 'Mike Carlson',
                    },
                    {
                        avatar: '3',
                        title: 'Alexis Baker',
                    },
                    {
                        avatar: '4',
                        title: 'Alexandre Connors',
                    },
                    {
                        avatar: '5',
                        title: 'Alex Connors',
                    },
                    {
                        avatar: '6',
                        title: 'Ali Connors',
                    },


                ],
                chats: [{
                        color: 'primary',
                        active: true,
                        avatar: 'trending_up',
                        title: 'Trade ',
                    },
                    {
                        color: 'primary',
                        active: true,
                        avatar: 'payments',
                        title: 'Payments',
                    },
                    {
                        color: 'primary',
                        avatar: 'psychology',
                        title: 'Bot Trader',
                    },
                    {
                        color: 'primary',
                        avatar: 'qr_code_scanner',
                        title: 'Promoction',
                    },



                ],
            }

        ),
        methods: {
            path() {
                return console.log(this.$router.push("/path"));
            },
            goLogin() {
                return this.$router.push("/");
            },
            goProfile() {
                return this.$router.push("/users/profile");
            },
            goInbox() {
                return this.$router.push("/apps/inbox");
            },
            goChat() {
                return this.$router.push("/users/chat");
            },
            goSettings() {
                return this.$router.push("/users/settings");
            },
        }

    }
</script>
<style>
     .card-light {
    border-radius: 1em;
    border: 1px solid rgba(255, 255, 255, 0.5);
    text-shadow: 0 0 1em rgba(0, 0, 0, 0.5);
    background: rgba(255, 255, 255, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }  .card-dark {
    border-radius: 1em;
    border: 1px solid rgba(0, 0, 0, 0.5);
    text-shadow: 0 0 1em rgba(245, 245, 245, 0.5);
    background: rgba(0, 0, 0, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }



    .search-wrapper {
        margin-left: 70px;
        border-radius: 8px;
        border: 1px solid #cb0c9f;
        background-color: transparent);
        padding-right: 12px;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        max-width: 300px;
        color: #cb0c9f;
        box-shadow: 0 2px 6px 0 rgba(136, 148, 171, 0.2), 0 24px 20px -24px rgba(71, 82, 107, 0.1);
        overflow: hidden;
    }

    .dark .search-wrapper {
        box-shadow: none;
    }

    .search-input {
        border: none;
        flex: 1;
        outline: 1px #cb0c9f;
        height: 100%;
        padding: 0 20px;
        font-size: 16px;
        background-color: #f3f6fd);
        color: var(--main-color);
    }

    .search-input:placeholder {
        color: var(--main-color);
        opacity: 0.6;
    }
</style>


<!--====  End of BASEMENU  ====-->